"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldToolbarCoreInputs = void 0;
const toolbar_color_1 = require("./toolbar.color");
class EmeraldToolbarCoreInputs {
    constructor() {
        this.color = toolbar_color_1.EmeraldToolbarColor.Primary;
        this.title = 'Tool bar title';
        this.navigateTo = '/';
        this.fixed = false;
    }
}
exports.EmeraldToolbarCoreInputs = EmeraldToolbarCoreInputs;
//# sourceMappingURL=toolbar.inputs.js.map